import anthropicLogo from "@/components/shared/img/anthropic.svg";
import deepseekLogo from "@/components/shared/img/deepseek.svg";
import geminiLogo from "@/components/shared/img/gemini.svg";
import mistralLogo from "@/components/shared/img/mistral.svg";
import openaiLogo from "@/components/shared/img/openai.svg";
import { cx } from "@/utils/classnames";
import type { StaticImageData } from "next/image";
import React from "react";

const createProviderIcon = (logo: StaticImageData, monochrome: boolean) => {
  const ProviderIcon: React.FC<React.ComponentProps<"svg">> = ({ className, ...props }) => (
    <svg viewBox="0 0 24 24" className={cx(className, monochrome && "dark:invert")} {...props}>
      <image href={logo.src} width="24" height="24" />
    </svg>
  );
  return ProviderIcon;
};

export const OpenAiIcon = createProviderIcon(openaiLogo, true);
export const AnthropicIcon = createProviderIcon(anthropicLogo, true);
export const GeminiIcon = createProviderIcon(geminiLogo, false);
export const DeepseekIcon = createProviderIcon(deepseekLogo, false);
export const MistralIcon = createProviderIcon(mistralLogo, false);
